<h2 mat-dialog-title>
  <mat-icon>schedule</mat-icon>
  Calendario de Servicios
</h2>

<mat-dialog-content class="mat-typography calendar-container">

  <!-- Leyenda -->
  <div class="calendar-legend">
    <div class="legend-item">
      <span class="legend-dot preventive"></span>
      <span>Mantenimiento Preventivo</span>
    </div>
    <div class="legend-item">
      <span class="legend-dot corrective"></span>
      <span>Mantenimiento Correctivo</span>
    </div>
  </div>

  <!-- Navegación del calendario -->
  <div class="calendar-header">
    <button mat-icon-button (click)="previousMonth()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <h3>{{ monthNames[currentMonth] }} {{ currentYear }}</h3>
    <button mat-icon-button (click)="nextMonth()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="calendar-content">
    <!-- Calendario -->
    <div class="calendar-grid">
      <!-- Días de la semana -->
      <div class="week-days">
        @for (day of weekDays; track day) {
          <div class="week-day">{{ day }}</div>
        }
      </div>

      <!-- Días del mes -->
      <div class="calendar-days">
        @for (calendarDay of calendarDays; track calendarDay) {
          <div
            class="calendar-day"
            [class.other-month]="!calendarDay.isCurrentMonth"
            [class.has-events]="calendarDay.hasEvents"
            [class.today]="calendarDay.isToday"
            (click)="onDayClick(calendarDay)">
            <span class="day-number">{{ calendarDay.day }}</span>
            <!-- Indicadores de eventos -->
            @if (calendarDay.hasEvents) {
              <div class="event-indicators">
                @for (event of calendarDay.events.slice(0, 3); track event) {
                  <span
                    class="event-dot"
                    [class.preventive]="event.type === 'preventivo'"
                    [class.corrective]="event.type === 'correctivo'">
                  </span>
                }
                @if (calendarDay.events.length > 3) {
                  <span class="more-events">
                    +{{ calendarDay.events.length - 3 }}
                  </span>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Panel de detalles -->
    @if (showDetailPanel) {
      <div class="detail-panel">
        <div class="detail-header">
          <h4>
            <mat-icon>event</mat-icon>
            Mantenimientos programados
          </h4>
          <button mat-icon-button (click)="closeDetailPanel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="detail-content">
          @for (event of selectedDayEvents; track event) {
            <mat-card class="maintenance-card">
              <mat-card-header>
                <mat-card-title>
                  <span class="maintenance-type-badge" [ngClass]="getMaintenanceTypeClass(event.type)">
                    {{ getMaintenanceTypeLabel(event.type) }}
                  </span>
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="equipment-info">
                  <div class="info-row">
                    <mat-icon>build</mat-icon>
                    <strong>Equipo:</strong> {{ event.equipment._equipment }} - {{ event.equipment._description }}
                  </div>
                  <div class="info-row">
                    <mat-icon>business</mat-icon>
                    <strong>Fabricante:</strong> {{ event.equipment._manufacturer }}
                  </div>
                  <div class="info-row">
                    <mat-icon>confirmation_number</mat-icon>
                    <strong>Serie:</strong> {{ event.equipment.serialNumber }}
                  </div>
                  <div class="info-row">
                    <mat-icon>qr_code</mat-icon>
                    <strong>Tag RFID:</strong> {{ event.equipment.tagRfid }}
                  </div>
                  <div class="info-row">
                    <mat-icon>info</mat-icon>
                    <strong>Estado:</strong> {{ event.equipment.status }}
                  </div>
                  <div class="info-row">
                    <mat-icon>category</mat-icon>
                    <strong>Tipo:</strong> {{ event.equipment.type }}
                  </div>
                  @if (event.maintenanceData.description) {
                    <div class="info-row">
                      <mat-icon>description</mat-icon>
                      <strong>Descripción:</strong> {{ event.maintenanceData.description }}
                    </div>
                  }
                  @if (event.maintenanceData.technician) {
                    <div class="info-row">
                      <mat-icon>person</mat-icon>
                      <strong>Técnico:</strong> {{ event.maintenanceData.technician }}
                    </div>
                  }
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
    }
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="warn">Cerrar</button>
</mat-dialog-actions>